<template>
  <v-navigation-drawer
      v-if="user"
      v-model="show_aside"
      app
      dark
      right
      clipped
  >
    <v-list
        nav
        dense
    >
      <v-list-item-group>
        <v-list-item v-if="hasPermission('etalon.catalog.manage')" @click="$router.push('/dashboard/admin/catalog')">
          <v-list-item-title>Управление каталогом</v-list-item-title>
        </v-list-item>
<!--        <v-list-item @click="$router.push('/dashboard/admin/content')">-->
<!--          <v-list-item-title>Контент</v-list-item-title>-->
<!--        </v-list-item>-->
<!--        <v-list-item @click="$router.push('/dashboard/admin/notification-create')">-->
<!--          <v-list-item-title>Уведомления</v-list-item-title>-->
<!--        </v-list-item>-->
<!--        <v-list-item @click="$router.push('/dashboard/admin/catalog-dropship-b2b')">-->
<!--          <v-list-item-title>Каталог DROPSHIP B2B</v-list-item-title>-->
<!--        </v-list-item>-->
        <v-list-item v-if="hasPermission('etalon.np.manage')
            || hasPermission('cylinder.np.manage')
            || hasPermission('drop.np.manage')" @click="$router.push('/dashboard/admin/nova-poshta-senders/cylinder')">
          <v-list-item-title>Отправители Новая Почта</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('rozetka.account.manage')" @click="$router.push('/dashboard/admin/rozetka-stores')">
          <v-list-item-title>Магазины Rozetka</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('drop.payment.contragent')" @click="$router.push('/dashboard/admin/payment-contragents/mono')">
          <v-list-item-title>Платежные контрагенты (DROP-IT)</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('cylinder.payment.contragent')" @click="$router.push('/dashboard/admin/cylinder/payment-contragents')">
          <v-list-item-title>Платежные контрагенты (Cylinder)</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('admin.role.manage')" @click="$router.push('/dashboard/admin/roles')">
          <v-list-item-title>Роли</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('admin.user.manage')" @click="$router.push('/dashboard/admin/workers')">
          <v-list-item-title>Пользователи системы</v-list-item-title>
        </v-list-item>
        <v-divider/>
        <v-list-item v-if="hasPermission('drop.settings')" @click="$router.push('/dashboard/admin/drop-settings')">
          <v-list-item-title>Настройки DROP-IT</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('cylinder.setting.manage')" @click="$router.push('/dashboard/admin/cylinder-settings')">
          <v-list-item-title>Настройки Cylinder</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('cylinder.article.manage')" @click="$router.push('/dashboard/admin/cylinder-pages')">
          <v-list-item-title>Страницы Cylinder</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('cylinder.blog.manage')" @click="$router.push('/dashboard/admin/cylinder-blogs')">
          <v-list-item-title>Blog Cylinder</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SettingsMenuAsideComponent',
  props: ['value'],
  computed: {
    ...mapGetters('auth', ['hasPermission']),
    ...mapState('auth', ['user']),
    show_aside: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  watch: {
    $route: function (v) {
      this.show_aside = false
    }
  }
}
</script>

<style scoped>

</style>
